import {
  inject,
  Injectable,
  Injector,
  ProviderToken,
  signal,
} from "@angular/core";

type LazyResult<T> = ProviderToken<T> | { default: ProviderToken<T> };

export function lazyInject<T>(
  providerLoader: Promise<LazyResult<T>> | (() => Promise<LazyResult<T>>),
) {
  const lazyInjector = inject(LazyInject);

  const lazySignal = signal<T | undefined>(undefined);

  void lazyInjector.get(providerLoader).then((provider) => {
    lazySignal.set(provider);
  });

  return lazySignal;
}

@Injectable({ providedIn: "root" })
export class LazyInject {
  private injector = inject(Injector);

  async get<T>(
    providerLoader: Promise<LazyResult<T>> | (() => Promise<LazyResult<T>>),
  ) {
    const awaited =
      typeof providerLoader === "function"
        ? await providerLoader()
        : await providerLoader;
    const res = "default" in awaited ? awaited.default : awaited;
    return this.injector.get(res);
  }
}
